import styled from "styled-components";
import { TopBannerDefaultBox } from './top-banner.default.box'
import {NEW_LIVE_CASINO_PAGE} from "../../../../themes/css-global-classes";

/**
 * After all banners will be replaced with ones of the same size remove this code
 * PC 1750 x 200 / Mobile 414 x 105
 * @deprecated
 */
export const TopBannerSIBox = styled(TopBannerDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.mAndBelow} {
    padding-bottom: calc(165 / 1024 * 100%);
    .${NEW_LIVE_CASINO_PAGE} & {
      padding-bottom: calc(165 / 1024 * 100%);
    }
 }

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    padding-bottom: calc(100 / 414 * 100%);
    .${NEW_LIVE_CASINO_PAGE} & {
      padding-bottom: calc(100 / 414 * 100%);
    }
  }

  background-color: ${({theme}) => theme.colors.backgroundDark};
`;